module.exports = __webpack_public_path__ + "img/selected7-min.5b0da2c4.png";